<template>
  <div id="top-results-containier" class="border-padding">
  <main>
    <div class="row">
      <div class="col-md-2"  v-if="$route.params.type == 'game' && season_dropdown.data != undefined">
        <label class="typo__label">Season (optional)</label>
        <multiselect
          v-model="season_selected"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :preselect-first="false"
          placeholder=""
          :options="season_dropdown.data"
          :searchable="false"
          :show-labels="false"
          :allow-empty="true">
          <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
        </multiselect>
      </div>

      <div class="col-md-2">
      <label class="typo__label">Season Type</label>
      <multiselect
        v-model="season_type_selected"
        select-label=""
        deselect-label=""
        track-by="id"
        label="text"
        :preselect-first="true"
        :options="season_type_options"
        :searchable="false"
        :show-labels="false"
        :allow-empty="false">
        <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
      </multiselect>
      </div>

      <div class="col-md-2">
        <label class="typo__label">Type</label>
        <multiselect
          v-model="entity_type_selected"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :preselect-first="true"
          placeholder=""
          :options="entity_type_dropdown"
          :searchable="false"
          :show-labels="false"
          :allow-empty="false">
          <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
        </multiselect>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2" v-if="stat_dropdown.data != undefined">
        <multiselect
          v-model="stat_selected"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :preselect-first="false"
          placeholder=""
          :options="stat_dropdown.data"
          :searchable="false"
          :show-labels="false"
          :allow-empty="false">
          <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
        </multiselect>
      </div>

      <div v-if="stat_selected && stat_selected.pct" class="border-padding">
        Min Denominator: <input v-model="min_cutoff" placeholder="" maxlength="99999" size="6">
      </div>
      <div class="border-padding">
        <input v-model="sort_ascending" type="checkbox"> Lowest to Highest
      </div>
    </div>

    <div class="border-padding">
      <button class="" v-on:click="changeStats()">Get Stats</button>
    </div>

    <div v-if="loading">
      Loading.....
    </div>
    <p style="color:red;" v-if="show_error_message">Error Getting Results</p>

    <div id="top-results-table-container" v-if="table_data.length > 0">
        <vue-good-table
            :columns="table_columns"
            :rows="table_data"
            :pagination-options="{ enabled: true, perPage: 50}"
            :searchOptions="{ enabled: false}"
            :sort-options="{ enabled: false}"
            styleClass="vgt-table bordered striped">
            <template slot="table-row" slot-scope="props">
              <div v-if="props.column.field == 'game_date'">
                <span :id="props.row.game_id">
                  <router-link :to="{ name: 'game_stats', params: { game_id: props.row.game_id, type: 'player' }}">{{props.formattedRow[props.column.field]}}</router-link>
                </span>
              </div>
              <div v-else-if="props.column.field == 'season'">
                <span :id="props.row.game_id">
                  <router-link :to="{ name: 'totals', params: { league: $route.params.league, type: $route.query.EntityType.toLowerCase() }, query: {Season: props.row.season, SeasonType: $route.query.SeasonType}}">{{props.formattedRow[props.column.field]}}</router-link>
                </span>
              </div>
              <div v-else>
                <span>
                  {{props.formattedRow[props.column.field]}}
                </span>
              </div>
            </template>
            <template slot="table-column" slot-scope="props">
            <span v-if="props.column.hover != undefined" v-b-tooltip.hover :title="props.column.hover">
                {{props.column.label}}
            </span>
            <span v-else>
                {{props.column.label}}
            </span>
            </template>
        </vue-good-table>
    </div>
  </main>
  </div>
</template>

<script>
import axios from 'axios'
import GetDropdownOptions from './mixins/get_dropdown'
import Multiselect from 'vue-multiselect'
import { rateStats } from './mixins/rate_stats'
import { tableUtils } from './mixins/table_utils'
import { season, topResults } from './mixins/dropdowns'

export default {
  name: 'TopResults',
  components: {
    Multiselect
  },
  mixins: [rateStats, tableUtils, GetDropdownOptions, season, topResults],
  data () {
    return {
      loading: false,
      season_dropdown: {},
      season_selected: undefined,
      season_type_selected: undefined,
      season_type_options: [
        {'id': 'Regular+Season', 'text': 'Regular Season'},
        {'id': 'Playoffs', 'text': 'Playoffs'}
      ],
      entity_type_dropdown: [
        {'id': 'Team', 'text': 'Team'},
        {'id': 'Opponent', 'text': 'Opponent'},
        {'id': 'Player', 'text': 'Player'},
        {'id': 'Lineup', 'text': 'Lineup'},
        {'id': 'LineupOpponent', 'text': 'Lineup Opponent'}
      ],
      entity_type_selected: undefined,
      stat_dropdown: {},
      stat_selected: undefined,
      min_cutoff: undefined,
      sort_ascending: false,
      table_data: [],
      table_columns: {},
      top_games_headers: [
        {'field': 'game_date', 'label': 'Date', 'type': 'date', 'dateInputFormat': 'yyyy-MM-dd', 'dateOutputFormat': 'yyyy/MM/dd'},
        {'field': 'name', 'label': 'Name'},
        {'field': 'team', 'label': 'Team'},
        {'field': 'opponent', 'label': 'Opponent'},
        {'field': 'stat_value', 'label': 'Stat Value', 'type': 'number'}
      ],
      top_seasons_headers: [
        {'field': 'season', 'label': 'Season'},
        {'field': 'name', 'label': 'Name'},
        {'field': 'team', 'label': 'Team'},
        {'field': 'stat_value', 'label': 'Stat Value', 'type': 'number'}
      ],
      show_error_message: false,
      api_endpoint: 'get-top-results/'
    }
  },
  created () {
    this.loadData()
  },
  watch: {
    '$route': 'updateData',
    '$parent.league': 'changeLeague'
  },
  methods: {
    changeLeague () {
      this.season_dropdown = {}
      this.season_selected = undefined
      this.entity_type_selected = undefined
      this.season_type_selected = undefined
      this.table_data = []
      this.$router.push({name: 'top_results', params: {league: this.$parent.league, type: this.$route.params.type}})
    },
    setTypeDropdown () {
      if (!this.entity_type_selected) {
        this.entity_type_selected = this.entity_type_dropdown[0]
      }

      if (this.$route.query.EntityType) {
        this.entity_type_dropdown.forEach((type) => {
          if (type.id === this.$route.query.EntityType) {
            this.entity_type_selected = type
          }
        })
      }
    },
    setSeasonDropdown () {
      this.season_dropdown = this.getSeasonDropdownForLeague(this.$parent.league)

      if (this.$route.query.Season) {
        this.season_dropdown.data.forEach((season) => {
          if (season.id === this.$route.query.Season) {
            this.season_selected = season
          }
        })
      }
    },
    setSeasonTypeDropdown () {
      if (!this.season_type_selected) {
        this.season_type_selected = this.season_type_options[0]
      }
      this.season_type_options.forEach((seasonType) => {
        if (seasonType.id === this.$route.query.SeasonType) {
          this.season_type_selected = seasonType
        }
      })
    },
    setStatDropdown () {
      this.stat_dropdown = this.top_results_stat_dropdown
      if (!this.stat_selected) {
        this.stat_selected = this.stat_dropdown.data[0]
      }
      this.stat_dropdown.data.forEach((stat) => {
        if (stat.id === this.$route.query.Stat) {
          this.stat_selected = stat
        }
      })
    },
    setMinCutoff () {
      if (this.$route.query.MinCutOff) {
        this.min_cutoff = this.$route.query.MinCutOff
      }
    },
    setSort () {
      if (this.$route.query.SortOrder === 'Asc') {
        this.sort_ascending = true
      }
    },
    checkIfStatsShouldBeLoaded () {
      if (this.$route.query.SeasonType && this.$route.query.EntityType) {
        this.getStats()
      }
    },
    loadData () {
      this.getDropdown([this.setSeasonDropdown, this.setSeasonTypeDropdown, this.setTypeDropdown, this.setStatDropdown, this.setMinCutoff, this.checkIfStatsShouldBeLoaded])
      this.setSort()
    },
    updateData () {
      this.table_data = []

      if (this.$route.query.SeasonType && this.$route.query.EntityType && this.$route.query.Stat) {
        this.getStats()
      } else {
        this.loadData()
      }
    },
    changeStats () {
      var params = {}
      if (this.season_selected) {
        params[this.$seasonParam] = this.season_selected.id
      }
      params[this.$seasonTypeParam] = this.season_type_selected.id
      params[this.$entityTypeParam] = this.entity_type_selected.id
      params[this.$statParam] = this.stat_selected.id
      if (this.min_cutoff && this.min_cutoff !== '' && this.stat_selected && this.stat_selected.pct) {
        params['MinCutOff'] = this.min_cutoff
      }
      if (this.sort_ascending) {
        params['SortOrder'] = 'Asc'
      }

      this.$router.push({name: 'top_results', query: params})
    },
    getStats () {
      this.show_error_message = false
      this.table_data = []
      var params = this.$route.query
      params[this.$typeParam] = this.$route.params.type

      if (params.SeasonType && params.EntityType && params.Stat) {
        this.loading = true
        axios.get(process.env.API_BASE_URL + this.api_endpoint + this.$route.params.league, {
          params: params
        })
          .then((response) => {
            if (!response.data.error) {
              this.table_data = response.data.results
              if (this.$route.params.type === 'game') {
                this.table_columns = this.top_games_headers
              } else {
                this.table_columns = this.top_seasons_headers
              }
            } else {
              this.show_error_message = true
            }
            this.loading = false
          }, (error) => {
            this.show_error_message = true
            this.loading = false
            this.error = error
          })
      }
    }
  }
}
</script>

<style scoped>
@import "https://maxcdn.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css"

</style>



// WEBPACK FOOTER //
// src/components/TopResults.vue